import * as React from 'react';
import styled from 'styled-components';
import { IconStyle } from '../Icon.styles.js';
const _IconCommerceAlcoholUnavailable = (props) => {
    const { 'data-test-id': dataTestId, className, size, style, ...rest } = props;
    return (React.createElement("span", { "data-test-id": dataTestId, className: className, style: style }, size === '24'
        ? React.cloneElement(React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" },
            React.createElement("path", { d: "M13 5a1 1 0 0 1 1 1v.818l-1.391 1.391A6.374 6.374 0 0 1 12.5 7v-.5h-1V7c0 1.657-.54 2.566-.964 3.272l-.015.025L8.5 12.318V12c0-1.25.375-1.875.75-2.5S10 8.25 10 7V6a1 1 0 0 1 1-1h2Zm9 7c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-1.5 0a8.5 8.5 0 0 1-13.957 6.517L8.5 16.561V18a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-6c0-.914-.2-1.494-.455-1.984l3.472-3.473A8.466 8.466 0 0 1 20.5 12ZM5.482 17.457 17.457 5.482A8.5 8.5 0 0 0 5.483 17.456Zm8.417-6.295c.065.226.101.49.101.838v5.5h-4v-2.44l3.899-3.898Z", fill: "currentColor", fillRule: "evenodd" })), { width: 24, height: 24, ...rest })
        : null));
};
const defaultProps = {
    size: '24',
};
export const IconCommerceAlcoholUnavailable = styled(_IconCommerceAlcoholUnavailable) `
    ${IconStyle}
`;
IconCommerceAlcoholUnavailable.defaultProps = defaultProps;
//# sourceMappingURL=IconCommerceAlcoholUnavailable.js.map